import React from "react";
import DataTable from "react-data-table-component";

function ShowDonationsFromOthers(props) {
  const dateSort = (rowA, rowB) => {
    // Convert date strings to Date objects
    var d1 = Date.parse(rowA.date);
    var d2 = Date.parse(rowB.date);

    // Compare the dates
    if (d1 < d2) {
      return 1;
    } else {
      return -1;
    }
  };

  const columns = [
    {
      name: "Donor Name",
      cell: (row) => row.donorName,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      sortFunction: dateSort,
    },
    {
      name: "Mode",
      selector: (row) => row.mode,
      sortable: true,
    },
    {
      name: "On Record",
      selector: (row) => row.onRecord,
      sortable: true,
    },
    {
      name: "Raised Through Platform",
      selector: (row) => row.raisedThroughPlatform,
      sortable: true,
    },
    {
      name: "Commission",
      selector: (row) => row.commissionAmount,
      sortable: true,
    },
    {
      name: "CSR Donation?",
      selector: (row) => row.csrDonation,
      sortable: true,
    },
    {
      name: "Received Through Website?",
      selector: (row) => row.receivedThroughWebsite,
      sortable: true,
    },
    {
      name: "Trust",
      selector: (row) => row.trust,
      sortable: true,
    },
  ];

  return (
    <div>
      <DataTable
        columns={columns}
        data={props.donations}
        keyField="id"
        striped
        highlightOnHover
        dense
        pagination
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5, 10, 20]}
      />
    </div>
  );
}

export default React.memo(ShowDonationsFromOthers);
